import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {mineShaft} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  container: {
    paddingTop: indent * 0.8,
    flex: 1,
  },
  title: {
    color: mineShaft,
    fontWeight: '600',
  },
  description: {
    color: mineShaft,
    paddingTop: indent * 0.4,
  },
  pointsContainer: {
    paddingTop: indent * 0.4,
  },
});
